export default __webpack_public_path__ + "static/media/breakthrough.774f70fa.png";